import React from 'react';
import moment from 'moment';

//styles
import { TableRowStyles, TableItemStyles } from '../../../../../SharedStyles';

//servies
import AppPlatformService from '../../../../../../services/AppPlatform/AppPlatformService';

const MiscFeesCard = (props) => {
  return (
    <TableRowStyles
      hoverBackground='#f1f7ff'
      borderTop='none'
      borderLeft='none'
      borderRight='none'
      align='center'
      width='761px'>
      <TableItemStyles width='100%'>
        {moment(props.date).format('MM/DD/YY h:mma')}
      </TableItemStyles>
      <TableItemStyles width='100%'>{props.description}</TableItemStyles>
      <TableItemStyles width='100%'>{AppPlatformService.currencyFormat(props.amount)}</TableItemStyles>
    </TableRowStyles>
  );
};

export default MiscFeesCard;
